import { useAuth } from "@/contexts/AuthContext";

export function SettingsPage() {
  const { user } = useAuth();
  return (
    <div className="p-6 space-y-4" data-testid="page-settings">
      <header>
        <h1 className="text-2xl font-semibold">Configuración</h1>
      </header>
      <div className="card space-y-1 text-sm">
        <div>
          <span className="text-muted-200">Usuario:</span> {user?.username}
        </div>
        <div>
          <span className="text-muted-200">Tenant:</span> {user?.tenantSlug}
        </div>
        <div>
          <span className="text-muted-200">Roles:</span> {user?.roles.join(", ")}
        </div>
        <div>
          <span className="text-muted-200">MFA:</span> {user?.mfaEnabled ? "habilitado" : "deshabilitado"}
        </div>
      </div>
      <div className="card text-sm text-muted-200">
        Próximamente: configuración por tenant (umbrales de anomalías, intervalos
        de sync, política de MFA por rol).
      </div>
    </div>
  );
}
